import { Button } from 'antd';
import React from 'react';
import style from '../../../Styles/SampleModal.module.css';
import {
  toastError,
  toastInfo,
  toastSuccess,
} from '../../Toast/ToastComponent';
import { TimeSheetApi } from '../../../Api/TimeSheetApi';
import { months } from 'moment';

const BillPopUp = ({
  toggleModal,
  userData,
  filterValue,
  getLogsList,
  getAttendanceReport,
  billableType,
}) => {
  const handleBillable = async () => {
    try {
      let body = {
        month: filterValue?.month,
        year: filterValue?.year,
        user_id: userData?.employee_id,
        setBillable: billableType == 'billable' ? true : false,
      };

      const response = await TimeSheetApi.setBillable(body);

      if (response?.data?.success) {
        toastSuccess(response?.data?.message);
        await getLogsList();
        await getAttendanceReport();
        toggleModal();
      } else {
        toastInfo(response?.data?.message);
        await getLogsList();
        await getAttendanceReport();
        toggleModal();
      }
    } catch (error) {
      //toastError(error.response.data.message);
      toastError(error);
    }
  };
  return (
    <div>
      <div className="mt-2 fs-6">
        {' '}
        {billableType == 'billable'
          ? 'Are you sure you want to mark all as billable?'
          : 'Are you sure you want to mark all as Non-billable?'}
      </div>
      <div className="antdBtn mt-4 text-center">
        <Button type="default" htmlType="button" onClick={toggleModal}>
          Cancel
        </Button>
        <Button onClick={handleBillable} type="primary" htmlType="submit">
          Update
        </Button>
      </div>
    </div>
  );
};

export default BillPopUp;
